<mat-spinner class="charts-loading-spinner" *ngIf="!readyToRender" diameter="75"></mat-spinner>
<div class='container-fluid'>
    <form [formGroup]="filtersFormGroup" class='row'>
      <div class=' col-12 ' [ngClass]='{"col-md-12":!showCheckCard, "col-md-8":showCheckCard}' >
        <mat-card class="graph-card" style="{{readyToRender ? {opacity: 1} : {opacity: 0} }}">
          <mat-card-header>
            <mat-card-title>{{ 'website.equipment.detail.charts.curve_fluid' | translate }}</mat-card-title>
          </mat-card-header>

          <mat-card-content id='graphCardAvg' class='p-0'>
            <div class="graph-container">
              <div class="graph-container-header-field">

                <button class='reload-pos' *ngIf="activeTab === chartDataType.INST"
                        (click) = "refreshAllData()"
                        mat-icon-button aria-label="Example icon button with a vertical three dot icon">
                  <mat-icon>refresh</mat-icon>
                </button>

                <mat-form-field class='datepicker-pos pv-sm-field' appearance="outline" *ngIf="activeTab === chartDataType.INST" (click)="instDatePicker.open()">
                  <mat-label>{{ 'website.equipment.detail.charts.period' | translate }}</mat-label>
                  <input
                    matInput
                    [matDatepickerFilter]="instDatePickerFilter"
                    [matDatepicker]="instDatePicker"
                    readonly
                    formControlName="instDateFilter"
                  />
                  <mat-datepicker-toggle   matSuffix [for]="instDatePicker">
                    <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker  #instDatePicker  ></mat-datepicker>
                </mat-form-field>

                <app-datepicker-range-preset class='datepicker-pos  pv-sm-field' [range]="rangeAvgFg" *ngIf="activeTab === chartDataType.AVG" (dateChangeEvent)="onDateRangeChange($event)"></app-datepicker-range-preset>

              </div>

              <mat-tab-group  mat-stretch-tabs="false" class='mt-4 '  (selectedTabChange)="selectedTabChange($event)" [selectedIndex]="activeTab">
                <mat-tab label="{{ 'website.equipment.detail.charts.daily' | translate }}" [disabled]="chartIsLoading" >


                </mat-tab>
                <mat-tab label="{{ 'website.equipment.detail.charts.average' | translate }}" [disabled]="chartIsLoading">

                </mat-tab>
              </mat-tab-group>

              <div *isLoading="{isLoading:chartIsLoading,hasContent:true}"  class='chart-container' >
                <highcharts-chart
                  class="chart"
                  [Highcharts]="Highcharts"
                  [options]="chartOptions"
                  *ngIf=" chartOptions && !chartIsLoading && !refresh"
                  [callbackFunction]="chartCallback"

                ></highcharts-chart>
              </div>
            </div>
          </mat-card-content>
        </mat-card>


        <app-synoptic-diagram  *ngIf="equipmentId && isEquipmentType(['PolarBox']) && showCheckCard" [equipment]="equipment"  ></app-synoptic-diagram>

      </div>

      <div class='col-md-4 col-12 filter-section ' *ngIf="showCheckCard">
        <app-dynamic-filter [initalFilterValue]="INITIAL_FILTERS_FILTERED" [filterCategories]="FILTERS" (changedValue)="refreshChart($event.changedValue)"></app-dynamic-filter>

      </div>
    </form>
</div>
